export const SET_SESSION_MESSAGES_STATE = 'HOME_SET_SESSION_MESSAGES_STATE';
export const SET_BROWSER_MESSAGES_STATE = 'HOME_SET_BROWSER_MESSAGES_STATE';
